import {defineStore} from "pinia";
import router from "@/router/index.js";
import {getAuthenticatedRequest} from "@/stores/AuthenticatedRequest.js";
import {useUserStore} from '@/stores/user.js';
import {useApi} from "@/services/useApi.js";

export const useCustomerStore = defineStore('customer', {
  state: () => ({
    selectedCustomer: {}
  }),
  getters: {},
  actions: {
    async action_searchCustomers(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2071,
        'search': {
          'keyword': payload.keyword
        }
      };
      //console.log('action_searchAccounts: ', request);
      return await useApi(
        request,
        (response) => {
          //console.log('action_searchAccounts Success: ', response);
          return response.data.search.relatedCustomers || [];
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return false;
          // userStore.resetUser(errorMessage);
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
          // userStore.setErrorMessage(errorMessage);
        }
      );
    },
    async action_addNewCustomer(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2003,
        "customer": payload
      };
      //console.log('action_addNewCustomer: ', request);
      /*return {
        result: true,
        data: {
          "store": payload.store,
          "storeID": payload.storeID,
          "name": payload.name,
          "id": payload.id ? payload.id : 1
        }
      }*/

      return await useApi(
        request,
        (response) => {
          //console.log('action_addNewCustomer Success: ', response);
          return {
            result: true,
            data: response.data.customer
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return false;
          // userStore.resetUser(errorMessage);
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
          // userStore.setErrorMessage(errorMessage);
        }
      );
    },
    async action_getCustomer(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2084,
        "customer": {
          "id": payload.id
        }
      };
      //console.log('action_addNewCustomer: ', request);
      return await useApi(
        request,
        (response) => {
          //console.log('action_addNewCustomer Success: ', response);
          return {
            result: true,
            data: response.data.customer
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return false;
          // userStore.resetUser(errorMessage);
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
          // userStore.setErrorMessage(errorMessage);
        }
      );
    },
    setSelectedCustomer(payload) {
      this.selectedCustomer = payload
    }
  },
  /*persist: {
    paths: [''],
  },*/
})
